<div class="profile-menu__header" data-testid="profile-header">
    <h2 class="profile-menu__title" data-testid="profile-title">{{ greeting }}, {{ profileMenu().name }}</h2>
    @if (profileMenu().subtitle) {
        <h3 class="profile-menu__subtitle" data-testid="profile-subtitle">{{ profileMenu().subtitle }}</h3>
    }
</div>

@for (group of profileMenu().groups; track parentIndex; let parentIndex = $index) {
    <div class="profile-menu__group" data-testid="profile-group">
        @if (group.title) {
            <h4 class="profile-menu__group-title" data-testid="profile-group-title">{{ group.title }}</h4>
        }
        <ul class="profile-menu__group-items" data-testid="profile-group-item-list">
            @for (item of group.items; track $index) {
                <li
                    ap-list-item
                    [icon]="item.icon"
                    [title]="item.title"
                    [subTitle]="item.subtitle"
                    [showBottomBorder]="true"
                    [actionType]="item.link ? 'externalLink' : 'internalLink'"
                    [badge]="item.notifications || 0"
                    (itemClicked)="itemClicked.emit(item)"
                    data-testid="profile-group-item"
                ></li>
            }
        </ul>
    </div>
}

<ap-button iconName="logout" (onClick)="loginLogout.emit(true)">Uitloggen</ap-button>
